import { Component, OnInit, ViewChild, TemplateRef} from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators } from "@angular/forms";
import { GridOptions, RowNode } from 'ag-grid-community';
import { BsModalService,BsModalRef}   from 'ngx-bootstrap/modal';
import { User } from '../../models/user.model';
import { Clinic } from '../../models/clinic.model';
import { Machine } from '../../models/machine.model';
import { AlertService } from '../../util/alert/alert.service';
import { LocalStorage } from '../../util/localstorage.service'; 
import { CommonFunctions } from '../../util/common-functions';
import { MachineDataService } from './machine-data.service';
import { ClinicDataService } from '../clinic/clinic-data.service';
import { MachineCustomCellComponent } from './machine-custom-cell/machine-custom-cell.component';
import { DatePipe } from '@angular/common';
import { Constants } from '../../util/constants';

@Component({
  selector: 'app-machine',
  templateUrl: './machine.component.html',
  styleUrls: ['./machine.component.scss']
})
export class MachineComponent implements OnInit {

  public paddingtop: number = 160;
  public iSForm: FormGroup;
  public loggedUser: User
  public machine:Machine;
  private gridApi: any;
  private gridColumnApi: any;
  public columnDefs: any;
  public rowData: any;
  public gridOptions : GridOptions
  public defaultColDef
  public id
  public clinicid
  public clinic
  public location
  public equipment
  public clinicname
  public clinicfilter
  public locationfilter
  public clinics: Array<any> =[]
  public locationid
  public locationname
  public locations: Array<any> =[]
  public equipmentid
  public equipmentname
  public equipments: Array<any> =[]
  public clinicsforfilter: Array<any> =[]
  public locationsforfilter: Array<any> =[]
  public selectedClinicItem: Array<any> =[]
  public selectedLocationItem: Array<any> =[]
  public selectedEquipmentItem: Array<any> =[]
  public selectedClinicFilter: Array<any> =[]
  public selectedLocationFilter: Array<any> =[]
  public machinename
  public macaddress
  public isactive
  public machinestatus
  public updateMode 
  public deleteMode
  public name
  public isAdminUser
  public clinicfilterpresent: boolean

  private commonFunctions: CommonFunctions = new CommonFunctions
  @ViewChild('add_edit_Machine') add_edit_Machine: TemplateRef<any>
  public ModalRef : BsModalRef 

  constructor(private router: Router, private formBuilder: FormBuilder,private alertService: AlertService,
    private machineService: MachineDataService,private clinicService: ClinicDataService,  private bsModalService :BsModalService) {

    var self = this;
    this.gridOptions = {
      rowData: this.rowData,
      columnDefs: this.columnDefs,
      enableColResize: true,
      enableSorting: true,
      rowSelection: "single",
      rowHeight: 35,
      rowDeselection: true,
      animateRows: true,
      rowBuffer: 20,
      context: {
        componentParent: this
      },
      paginationPageSize: 10
    };

    this.defaultColDef = {
      //autoHeight: true,
      resizable: true,
      filter: true,
    };

    this.columnDefs = [
      { 
        headerName: 'MachineId', 
        field: 'id',
        hide: true
      },
      { 
        headerName: 'ClinicId', 
        field: 'clinicid',
        hide: true
      },
      { 
        headerName: 'Clinic Name', 
        field: 'clinicname',
        width: 30,
      },
      { 
        headerName: 'Location Name', 
        field: 'locationname',
        width: 30,
      },
      // {
      //   headerName: 'Machine Type', 
      //   field: 'equipmentshortname',
      //   width: 30,
      // },
      {
        headerName: 'Machine Name', 
        field: 'machinename',
        width: 30,
      },
      {
        headerName: 'Mac Address', 
        field: 'macaddress',
        width: 30,
      },
      { 
        headerName: 'Status', 
        field: 'isactive',
        width: 30,
      },
      { 
        headerName: '', 
        field: 'edit_delete',
        width: 25,
        cellStyle: {textAlign: "center"},
        cellRendererFramework: MachineCustomCellComponent,
      } ,
    ];
   }

  ngOnInit(): void {

    this.loggedUser   = JSON.parse(localStorage.getItem(LocalStorage.LOGGED_USER)) as User;
    if(this.loggedUser.UserRoleID == Constants.UserRoleID.AdminUser){
      this.isAdminUser = true
    } else{
      this.isAdminUser = false
    }
    this.iSForm = this.formBuilder.group({
      name: new FormControl(null),
      clinic: new FormControl(null),
      clinicname: new FormControl(null),
      location: new FormControl(null),
      locationname: new FormControl(null),
      equipment: new FormControl(null),
      equipmentname: new FormControl(null),
      clinicfilter: new FormControl(null),
      locationfilter: new FormControl(null),
      machinename: new FormControl(null),
      macaddress: new FormControl(null),
      isactive: new FormControl(null),
    } ); 

    this.loadData()
    this.loadClinicData()
  }

  externalFilterChanged() {
    if(this.gridApi != undefined){
      this.gridApi.onFilterChanged();
    }  
  }

  isExternalFilterPresent() {
    return true;
  }

  doesExternalFilterPass = (node: RowNode): boolean => {

    var MachineName = node.data.machinename.toLowerCase()
    var Clinicname = node.data.clinicname.toLowerCase()
    var Locationname = node.data.locationname.toLowerCase()

    //To check whether the filter is present
    var isClinicFilterNotPresent = (this.clinicfilter == null || this.clinicfilter == undefined || this.clinicfilter == "" || this.clinicfilter == Constants.DefaultValues.DropDownValue)
    var isNameFilterNotPresent = (this.name == null || this.name == undefined || this.name == "")
    var isLocationfilterFilterNotPresent = (this.locationfilter == null || this.locationfilter == undefined || this.locationfilter == "" || this.locationfilter == Constants.DefaultValues.DropDownValue)

    //To check whether the filter is true
    var isClinicFilterTrue : boolean = false
    if (!isClinicFilterNotPresent)
      isClinicFilterTrue = (Clinicname == this.clinicfilter.toLowerCase())

    var isLocationFilterTrue : boolean = false
    if (!isLocationfilterFilterNotPresent)
      isLocationFilterTrue = (Locationname.includes(this.locationfilter.toLowerCase()))

    var isMachineFilterTrue : boolean = false
    if (!isNameFilterNotPresent)
      isMachineFilterTrue=(MachineName.includes(this.name.toLowerCase())) 
    
    // Return true for node which fulfil filter criteria
    if ((isClinicFilterNotPresent || (!isClinicFilterNotPresent && isClinicFilterTrue)) &&
        ((isLocationfilterFilterNotPresent || !isLocationfilterFilterNotPresent && isLocationFilterTrue)) &&
        ((isNameFilterNotPresent || !isNameFilterNotPresent && isMachineFilterTrue)))
    {
      return true
    }    

  //OLD CODE
   /*  var MachineName = node.data.machinename.toLowerCase()
    var Clinicname = node.data.clinicname.toLowerCase()
    var Locationname = node.data.locationname.toLowerCase()

    var isClinicFilterNotPresent = (this.clinicfilter == null || this.clinicfilter == undefined || this.clinicfilter == "" || this.clinicfilter == Constants.DefaultValues.DropDownValue)
    var isNameFilterNotPresent = (this.name == null || this.name == undefined || this.name == "")
    var isLocationfilterFilterNotPresent = (this.locationfilter == null || this.locationfilter == undefined || this.locationfilter == "" || this.locationfilter == Constants.DefaultValues.DropDownValue)

    if(isClinicFilterNotPresent && isNameFilterNotPresent && isLocationfilterFilterNotPresent){
      return true
    } else if (!isClinicFilterNotPresent && isNameFilterNotPresent && isLocationfilterFilterNotPresent && (Clinicname == this.clinicfilter.toLowerCase())){
        return true
    } else if (!isClinicFilterNotPresent && !isLocationfilterFilterNotPresent && isNameFilterNotPresent && (Clinicname == this.clinicfilter.toLowerCase()) && Locationname.includes(this.locationfilter.toLowerCase())){
        return true
    }else if(!isNameFilterNotPresent && isClinicFilterNotPresent){
      if(MachineName.includes(this.name.toLowerCase())){
        return true
      }     
    } else if(!isNameFilterNotPresent && !isClinicFilterNotPresent && isLocationfilterFilterNotPresent){
      if(MachineName.includes(this.name.toLowerCase()) && (Clinicname == this.clinicfilter.toLowerCase())){
        return true
      }
    } else if(!isNameFilterNotPresent && !isClinicFilterNotPresent && !isLocationfilterFilterNotPresent){
      if(MachineName.includes(this.name.toLowerCase()) && (Clinicname == this.clinicfilter.toLowerCase()) && Locationname.includes(this.locationfilter.toLowerCase())){
        return true
      }
    } */
  }

  sortLocationRemainingFilters(){
    if((this.selectedClinicFilter["Location"] != null && this.selectedClinicFilter["Location"] != undefined) || (this.clinicname != null && this.clinicname != undefined)) {
      this.locationsforfilter = []
      this.locationsforfilter.push({LocationID: "0", LocationName: Constants.DefaultValues.DropDownValue});
      if(this.clinicfilter == Constants.DefaultValues.DropDownValue){
        this.selectedLocationFilter = this.locationsforfilter[0]
      }
      this.selectedClinicFilter["Location"].forEach((element: any) => {
        if((element.LocationName == Constants.DefaultValues.LocationName) && (element.LocationName != this.selectedLocationFilter["LocationName"])){
          this.locationsforfilter.push({LocationID: element.LocationID, LocationName: element.LocationName});
        }
      });
      this.selectedClinicFilter["Location"].forEach((element: any) => {
        if((element.LocationName != Constants.DefaultValues.LocationName) && (element.LocationName != this.selectedLocationFilter["LocationName"])){
          this.locationsforfilter.push({LocationID: element.LocationID, LocationName: element.LocationName});
        }
      });
    }
  }

  sortClinicRemainingFilters(){
    this.clinicsforfilter = []
    this.clinicsforfilter.push({ClinicID: "0", ClinicName: Constants.DefaultValues.DropDownValue, Location: null});
    if((this.selectedClinicFilter["ClinicName"] != Constants.DefaultValues.DropDownValue) && this.selectedClinicFilter != null && this.selectedClinicFilter != undefined && this.selectedClinicFilter.length != 0){
      this.clinics.forEach((element: any) => {
        if(element.ClinicName != this.selectedClinicFilter["ClinicName"]){
          this.clinicsforfilter.push({ClinicID: element.ClinicID, ClinicName: element.ClinicName, Location: element.Location});
        }
      });
    } else{
      this.clinics.forEach((element: any) => {
          this.clinicsforfilter.push({ClinicID: element.ClinicID, ClinicName: element.ClinicName, Location: element.Location});
      });
      this.selectedClinicFilter = this.clinicsforfilter[0]
    }
  }

  clinicFilter(): void {
    if(this.selectedClinicFilter != null && this.selectedClinicFilter != undefined){
      this.clinicfilter = this.selectedClinicFilter["ClinicName"]
      this.sortClinicRemainingFilters()
      if(this.clinicfilter != null && this.clinicfilter != undefined && this.clinicfilter != "" && this.clinicfilter != Constants.DefaultValues.DropDownValue){
        this.selectedLocationFilter = []
        this.locationFilter()
        this.sortLocationRemainingFilters()
        this.gridOptions.columnApi.setColumnVisible('clinicname', false)
        this.gridOptions.api.sizeColumnsToFit();
      } else{
        this.selectedLocationFilter = []
        this.locationFilter()
        if(!this.isAdminUser){
          this.gridOptions.columnApi.setColumnVisible('clinicname', true)
          this.gridOptions.api.sizeColumnsToFit();
        }
      }
    } else{
      this.clinicfilter = ""
      this.selectedLocationFilter = []
      this.locationFilter()
      if(!this.isAdminUser){
        this.gridOptions.columnApi.setColumnVisible('clinicname', true)
        this.gridOptions.api.sizeColumnsToFit();
      }
    }
	  this.searchBtnClickEvent()
  }

  locationFilter(): void {
    if(this.selectedLocationFilter != null && this.selectedLocationFilter != undefined && this.selectedLocationFilter.length != 0){
      this.locationfilter = this.selectedLocationFilter["LocationName"]
      this.sortLocationRemainingFilters()
      if(this.locationfilter != null && this.locationfilter != undefined && this.locationfilter != "" && this.locationfilter != Constants.DefaultValues.DropDownValue){
        this.gridOptions.columnApi.setColumnVisible('locationname', false)
        this.gridOptions.api.sizeColumnsToFit();
      } else{
        this.gridOptions.columnApi.setColumnVisible('locationname', true)
        this.gridOptions.api.sizeColumnsToFit();
      }
    } else{
      this.locationfilter = ""
      this.locationsforfilter = []
      this.locationsforfilter.push({LocationID: "0", LocationName: Constants.DefaultValues.DropDownValue});
      this.selectedLocationFilter = this.locationsforfilter[0]
      this.gridOptions.columnApi.setColumnVisible('locationname', true)
      this.gridOptions.api.sizeColumnsToFit();
    }
  this.searchBtnClickEvent()
  }

  loadData()
	{
    this.alertService.clear()
    if(this.isAdminUser){
      this.machineService.getMachines(this.loggedUser.ClinicID,this.loggedUser).subscribe(data => this.getData(data))
    } else{
      this.machineService.getMachines(null,this.loggedUser).subscribe(data => this.getData(data))
    }
    this.machineService.getEquipments(this.loggedUser).subscribe(data => this.getEquipmentData(data))
  }
  
  loadClinicData()
	{
    this.alertService.clear()
    this.clinicService.getClinics(this.loggedUser).subscribe(data => this.getClinicData(data))
	}

  public getData(data: any) {
    let machines: Array<any>=[] 
	  let activeStatus: String
    data.forEach((element: any) => {
      let machine: Machine = element
      machine.MachineID = element.MachineID
      machine.ClinicID = element.ClinicID
      machine.ClinicName = element.ClinicName
      machine.LocationID = element.LocationID
      machine.EquipmentID = element.EquipmentID
      machine.LocationName = element.LocationName
      machine.MachineName = element.MachineName
      machine.EquipmentShortName = element.EquipmentShortName
      machine.MacAddress = element.MacAddress
      machine.IsActive = element.IsActive
      if(machine.IsActive == true){
        activeStatus = Constants.MachineStatus.Active
      } else{
        activeStatus = Constants.MachineStatus.Inactive
      }  
      machines.push({id: machine.MachineID, clinicid: machine.ClinicID, clinicname: machine.ClinicName, 
        locationid: machine.LocationID, equipmentid: machine.EquipmentID, locationname: machine.LocationName,
         machinename: machine.MachineName ,equipmentshortname: machine.EquipmentShortName, macaddress: machine.MacAddress, isactive: activeStatus})
  
    setTimeout(()=> {
      this.gridApi.forEachNode(node => {
        if ( node.rowIndex  === 0 ){ 
          node.setSelected(true)
          this.id = node.data.id
          this.clinicid = node.data.clinicid
          this.locationid = node.data.locationid
          this.equipmentid = node.data.equipmentid
          this.machinename = node.data.machinename
          this.macaddress = node.data.macaddress
          this.isactive = node.data.isactive
          this.updateMode = false
          this.deleteMode = false
        } 
      }); 
    
    }, 50); 
    });
    this.rowData = machines;
    this.cancelBtnClickEvent();
    this.initializeMachineDetails();
    return this.rowData;
  }

  public getClinicData(data: any) {
    this.clinics = data
    if(!this.updateMode){
      this.clinicsforfilter = []
      this.clinicsforfilter.push({ClinicID: "0", ClinicName: Constants.DefaultValues.DropDownValue, Location: null});
      this.selectedClinicFilter = this.clinicsforfilter[0]

      this.locationsforfilter = []
      this.locationsforfilter.push({LocationID: "0", LocationName: Constants.DefaultValues.DropDownValue});
      this.selectedLocationFilter = this.locationsforfilter[0]
    }
	
    this.selectedClinicItem = []
    this.selectedLocationItem = []
    data.forEach((element: any, index: any) => {
      if(!this.updateMode){
        this.clinicsforfilter.push({ClinicID: element.ClinicID, ClinicName: element.ClinicName, Location: element.Location});
      }
      if(this.clinicid != null && this.clinicid != undefined && this.clinicid == element.ClinicID){
        if(this.isAdminUser){
          this.clinicname = element.ClinicName
          this.locations = element.Location
          element.Location.forEach((e: any) => {
            if(this.locationid != null && this.locationid != undefined && this.locationid == e.LocationID){
              this.locationname = e.LocationName
            }
            this.locationsforfilter.push({LocationID: e.LocationID, LocationName: e.LocationName});
          });
        } else{
          element.Location.forEach((e: any) => {
            if(this.locationid != null && this.locationid != undefined && this.locationid == e.LocationID){
              this.locationname = e.LocationName
              this.selectedLocationItem = e
            }
          });
        }
        this.selectedClinicItem = element
        if(!this.updateMode){
          this.selectedClinicFilter = this.clinicsforfilter[index+1]
        }        
      }
    });
    return this.clinics;
  }

  public getEquipmentData(data: any) {
    this.equipments = data
    this.selectedEquipmentItem = []
    data.forEach((element: any) => {
      if(this.equipmentid != null && this.equipmentid != undefined && this.equipmentid != ""){
        if(this.equipmentid == element.EquipmentID){
            this.equipmentname = element.EquipmentName
            this.selectedEquipmentItem = element
        }
      } else if(element.EquipmentName == Constants.EquipmentName.Default){
        this.equipmentid = element.EquipmentID
        this.equipment = element
        this.equipmentname = element.EquipmentName
        this.selectedEquipmentItem = element
      }
    });
    return this.equipments;
  }

  sortLocationRemainingOptions(){
    this.locations = []
    if(this.selectedClinicItem["Location"] != null && this.selectedClinicItem["Location"] != undefined){
      if(this.selectedLocationItem != null && this.selectedLocationItem != undefined && this.selectedLocationItem.length != 0){
        this.selectedClinicItem["Location"].forEach((element: any) => {
          if((element.LocationName == Constants.DefaultValues.LocationName) && (element.LocationName != this.selectedLocationItem["LocationName"])){
            this.locations.push(element);
          }
        });
        this.selectedClinicItem["Location"].forEach((e: any) => {
          if((e.LocationName != Constants.DefaultValues.LocationName) && (e.LocationName != this.selectedLocationItem["LocationName"])){
            this.locations.push(e);
          }
        });
      } else{
        this.selectedLocationItem = []
        this.location = ""
        this.selectedClinicItem["Location"].forEach((element: any) => {
          if(element.LocationName == Constants.DefaultValues.LocationName){
            this.locations.push(element);
          }
        });
        this.selectedClinicItem["Location"].forEach((e: any) => {
          if(e.LocationName != Constants.DefaultValues.LocationName){
            this.locations.push(e);
          }
        });
      }
    }
  }

  public selectedClinic(event: any): void {
    this.selectedLocationItem = []
    this.locationid = ""
    if(this.selectedClinicItem != null && this.selectedClinicItem != undefined){
      this.sortLocationRemainingOptions()
      this.clinicid = this.selectedClinicItem["ClinicID"]
    } else{
      this.clinicid = ""
      this.locations = []
    }  
  }
  
  public selectedLocation(event: any): void {
    if(this.selectedLocationItem != null && this.selectedLocationItem != undefined){
      this.locationid = this.selectedLocationItem["LocationID"]
      this.sortLocationRemainingOptions()
    } else{
      this.locationid = ""
    }
  }
  
  public selectedEquipment(event: any): void {
    if(this.selectedEquipmentItem != null && this.selectedEquipmentItem != undefined){
      this.equipmentid = this.selectedEquipmentItem["EquipmentID"]
    } else{
      this.equipmentid = ""
    }
	}

  initializeMachineDetails()
  {
    this.id = ""
    if(this.isAdminUser){
      this.clinicid = this.loggedUser.ClinicID
      this.getClinicData(this.clinics)      
    } else{
      this.clinicid = ""
      this.clinicname = ""
      this.location = ""
      this.locations = []
      this.locationid = ""
      this.locationname = ""
      this.selectedLocationItem = []
      this.selectedClinicItem = []
    }
    this.clinic = ""
    this.equipmentid = ""
    this.selectedEquipmentItem = []
    this.getEquipmentData(this.equipments)
    this.machinename = ""
    this.macaddress = ""
    this.isactive = true

    this.updateMode = false 
    this.deleteMode = false 
  }

  cancelBtnClickEvent(){
    this.name = null
    if(this.isAdminUser){
      this.clinicfilter = this.clinicname
    } else{
      this.clinicfilter = Constants.DefaultValues.DropDownValue
    }
    this.locationfilter = Constants.DefaultValues.DropDownValue
    //this.selectedClinicFilter = this.clinicsforfilter[0]
    this.selectedClinicFilter = []
    this.sortClinicRemainingFilters()
    if(this.isAdminUser){
      this.getClinicData(this.clinics)
    } else{
      this.locationsforfilter = []
      this.locationsforfilter.push({LocationID: "0", LocationName: Constants.DefaultValues.DropDownValue});
      this.selectedLocationFilter = this.locationsforfilter[0]
    }
    if(!this.isAdminUser){
      this.gridOptions.columnApi.setColumnVisible('clinicname', true)
    } else{
      this.gridOptions.columnApi.setColumnVisible('clinicname', false)
    }
    this.gridOptions.columnApi.setColumnVisible('locationname', true)
    this.gridOptions.api.sizeColumnsToFit();
    this.externalFilterChanged()
  }
  

  // exitBtnClickEvent(){ 
  //   this.router.navigateByUrl('landing'); 
  // }

  searchBtnClickEvent(){
    this.alertService.clear()
    this.externalFilterChanged()
  }

  editMachine(data: any){
    this.alertService.clear()
    this.initializeMachineDetails()
    this.id = data.id
    this.machinename = data.machinename
	  this.clinicname = data.clinicname
    this.macaddress = data.macaddress
    if(data.isactive == Constants.MachineStatus.Active){
      this.isactive = true
    } else{
      this.isactive = false
    }
    if(this.isAdminUser){
      this.machinestatus = this.isactive
    }
    this.updateMode = true 
    this.locationid = data.locationid
    this.equipmentid = data.equipmentid
    this.getEquipmentData(this.equipments) 
    this.clinicid = data.clinicid
    this.getClinicData(this.clinics)     
    this.ModalRef = this.bsModalService.show(this.add_edit_Machine)
  }

  deleteMachine(data: any){
    this.alertService.clear()
    this.initializeMachineDetails()
    if (confirm("Are you sure you want to delete selected record?")) { 
      this.id = data.id
      this.clinicid = data.clinicid
      this.machinename = data.machinename
      this.macaddress = data.macaddress
      this.isactive = data.isactive
      this.deleteMode = true
      this.saveMachineDetails()
    }
  }

  addnewmachine(){
    this.alertService.clear()
    this.ModalRef = this.bsModalService.show(this.add_edit_Machine)
    this.initializeMachineDetails()
  }

  validateMachine():boolean
  { 
    if(!this.deleteMode){
        if(!this.isAdminUser){
          if ((this.iSForm.controls.clinic.value == ""  || 
          this.iSForm.controls.clinic.value == null ))
          { 
            this.alertService.clear()
            this.alertService.error('Invalid Clinic')
            return false
          }
        } else{
          if ((this.iSForm.controls.clinicname.value == ""  || 
          this.iSForm.controls.clinicname.value == null ))
          { 
            this.alertService.clear()
            this.alertService.error('Invalid Clinic')
            return false
          }
        }

        if(!this.updateMode){
          if ((this.iSForm.controls.location.value == ""  || 
          this.iSForm.controls.location.value == null ))
          { 
            this.alertService.clear()
            this.alertService.error('Invalid Location')
            return false
          }
          if ((this.iSForm.controls.equipment.value == ""  || 
          this.iSForm.controls.equipment.value == null ))
          { 
            this.alertService.clear()
            this.alertService.error('Invalid Equipment')
            return false
          }
        }

        if ((this.iSForm.controls.machinename.value == ""  || 
        this.iSForm.controls.machinename.value == null ))
        { 
          this.alertService.clear()
          this.alertService.error('Invalid Machine Name')
          return false
        } else{
            //check for existing machine name
            var i
			      if(!this.updateMode){
				      for(i = 0; i < this.rowData.length; i++){
                if((this.iSForm.controls.machinename.value == this.rowData[i].machinename) && (this.clinicid == this.rowData[i].clinicid) && (this.locationid == this.rowData[i].locationid)){
                  this.alertService.clear()
                  this.alertService.error('Machine Name already exist in the clinic location')
                  return false           
                }
			      }
			    } else{
				      for(i = 0; i < this.rowData.length; i++){
                if((this.iSForm.controls.machinename.value == this.rowData[i].machinename) && (this.clinicid == this.rowData[i].clinicid) && (this.locationid == this.rowData[i].locationid) && (this.id != this.rowData[i].id)){
                  this.alertService.clear()
                  this.alertService.error('Machine Name already exist in the clinic location')
                  return false  
                }
              }
			    } 
        }

        // var macregex = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/;
        var macregex = /^[ A-Za-z0-9:-]*$/
        if ((this.iSForm.controls.macaddress.value == ""  || 
              this.iSForm.controls.macaddress.value == null ))
        { 
          this.alertService.clear()
          this.alertService.error('Invalid Mac Address')
          return false
        } else if(!macregex.test(this.iSForm.controls.macaddress.value)){
          this.alertService.clear()
          this.alertService.error('Invalid Mac Address')
          return false
        }else{
          //check for existing MAC Address
            var i
			      if(!this.updateMode){
				      for(i = 0; i < this.rowData.length; i++){
                if((this.iSForm.controls.macaddress.value == this.rowData[i].macaddress) && (this.clinicid == this.rowData[i].clinicid)){
                  this.alertService.clear()
                  this.alertService.error('Mac Address already exist')
                  return false           
                }
			      }
			    } else{
				      for(i = 0; i < this.rowData.length; i++){
                if((this.iSForm.controls.macaddress.value == this.rowData[i].macaddress) && (this.clinicid == this.rowData[i].clinicid) && (this.id != this.rowData[i].id)){
                  this.alertService.clear()
                  this.alertService.error('Mac Address already exist')
                  return false  
                }
              }
			    }    
        }
    } 
    return true
  }

  saveMachineDetails(){
    if (this.validateMachine()){
      this.machine = new Machine()
      this.machine.ClinicID = this.clinicid
      this.machine.LocationID = this.locationid
      this.machine.EquipmentID = this.equipment.EquipmentID
      this.machine.MachineName = this.machinename
      this.machine.MacAddress = this.macaddress
      if(!this.isAdminUser){
        this.machine.IsActive = this.isactive
      }else{
        this.machine.IsActive = this.machinestatus
      }
      this.machine.CreatedBy = this.loggedUser.UserID
      this.machine.CreatedOn = new Date()
      if(this.id == ""){
        this.machine.MachineID =  this.commonFunctions.getnewguid() 
      } else{
        this.machine.MachineID =  this.id
      }
      if(this.deleteMode)
      {
        this.machine.bDeleted = Constants.bDeleted.True
        this.machine.DeletedBy = this.loggedUser.UserID
        this.machine.DeletedOn = new Date()
      } else{
        this.machine.bDeleted = Constants.bDeleted.False
      }
      this.machineService.saveMachine(this.machine, this.loggedUser).subscribe(data =>
      {
        this.alertService.clear()
        this.loadData()
        if(this.updateMode && !this.deleteMode){
          this.alertService.success('Successfully updated')
        } else if(this.deleteMode){
          this.alertService.success('Successfully deleted')
        } else{
          this.alertService.success('Successfully saved')
        }
        this.cancelModal()
        
      },
      error => { 
        this.alertService.clear()
        if(error.error.Status == "400"){
          this.alertService.error(error.error.ErrorMessage)
        }else{
          this.alertService.error('Error occured while saving data')
          this.loadData()
        } 
       });
    }
    
  }

  cancelModal(){
    this.ModalRef.hide()
  }

  gridSizeChanged(params: any) {
		params.api.sizeColumnsToFit();
  }

  onGridReady(params: any) { 
    this.rowData = []
		this.gridApi  = params.api;
    this.gridColumnApi = params.columnApi; 
    this.gridApi.sizeColumnsToFit();
  }

}

